export default{
    SET_SELF_SUGGESTION : (state, suggestion) => {
        state.game.lastSuggestionSelf.push(suggestion)
    },
    SET_EQUATION_FINAL : (state, equationFinal) => {
        state.game.equationFinal = equationFinal
    },
    SET_START_GAME : (state, startGame) => {
        state.game.startGame = startGame
    },
    SET_EQUAL : (state, data) => {
        state[data[0]][data[1]] = data[2]
    },
    SET_OPENED_ENIGNA:(state, currentOpenedEnigma) =>{
        state.game.enigmas = currentOpenedEnigma
    }
}